import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const qc = useQueryClient();
  const nav = useNavigate();

  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() =>
      api.post("/auth/refresh").then((r) => setUser(r.data)).catch(() => setUser(false)));
    const off = () => { toast.dismiss(); setUser(false); qc.clear(); };
    window.addEventListener("auth:logout", off);
    return () => window.removeEventListener("auth:logout", off);
  }, [qc]);

  const login = useCallback(async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    qc.clear();
    toast.dismiss();
    nav("/", { replace: true });
    setUser(r.data);
  }, [qc, nav]);

  const logout = useCallback(async () => {
    await api.post("/auth/logout").catch(() => {});
    qc.clear();
    toast.dismiss();
    nav("/", { replace: true });
    setUser(false);
  }, [qc, nav]);

  return <AuthCtx.Provider value={{ user, setUser, login, logout, isAdmin: user?.role === "admin", isAccountant: user?.role === "accountant" }}>{children}</AuthCtx.Provider>;
};

export const useAuth = () => useContext(AuthCtx);
